import { vaultGetRequest } from '../helpers';
import type { IFetchUploadStatusResponse } from './fetch-upload-status-response';
import { fetchUploadStatusResponseSchema } from './fetch-upload-status-response';

export async function fetchUploadStatusApi(): Promise<IFetchUploadStatusResponse> {
  return vaultGetRequest({ path: '/upload/status', schema: fetchUploadStatusResponseSchema });
}
